module.exports = "https://qp-assets.quero.com/assets/images/credit-card-brands/discover-nobg.svg?a7f4ee2996a6464620dd9a2c65cda9a4";